import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const targetId = decodeURIComponent(location.hash.slice(1));
      let attempts = 0;
      let timerId;

      const scrollToHashTarget = () => {
        const targetElement = document.getElementById(targetId);

        if (targetElement) {
          targetElement.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
          return;
        }

        if (attempts < 30) {
          attempts += 1;
          timerId = window.setTimeout(scrollToHashTarget, 150);
        }
      };

      scrollToHashTarget();

      return () => {
        if (timerId) {
          window.clearTimeout(timerId);
        }
      };
    }

    window.scrollTo({ top: 0, behavior: "auto" });
    return undefined;
  }, [location.pathname, location.hash]);

  return null;
}
